/* eslint-disable */
import bugsnag from 'bugsnag-js';
const bugsnagClient = bugsnag('fdff41b8f7549e8e1cece46ca51f4018');
/* eslint-disable */

import React, { Component } from 'react'
import { Route } from 'react-router-dom'

import App from '../App';

// Cadastro e Login
import authRoutes from './auth';

//bugsnag
import createPlugin from 'bugsnag-react';
const ErrorBoundary = bugsnagClient.use(createPlugin(React));

export default class Routes extends Component {
  render() {
    return (
      <ErrorBoundary>
        <App>
          <Route path="/">
            {authRoutes()}
          </Route>
        </App>
      </ErrorBoundary>
    )
  }
};
